import { Tooltip } from '@mantine/core';
import { getWorklogStatusText } from '@/features/types';
import { WorklogIcon } from '@/views/map/worklog/WorklogIcon/WorklogIcon';
import type { WorkLogStatus } from '@/generated/types/navigator/types.gen';

type Props = {
  workStatus: WorkLogStatus;
};

export const Level3WorkStatus = (props: Props) => {
  return (
    <Tooltip
      label={getWorklogStatusText(props.workStatus)}
      withArrow
      styles={() => ({
        tooltip: { background: 'rgba(46, 46, 46, 0.8)' },
      })}
    >
      <WorklogIcon workStatus={props.workStatus} />
    </Tooltip>
  );
};
